<template>
  <component :is="wrapper" class="mt-2 mb-2">
    <v-dialog
      v-if="showButtons == null || showButtons === true"
      v-model="dialog"
    >
      <ListForm
        :key="listUpdates"
        :entity-id="entityId"
        mode="just-list"
        :hard-filters="hardFilters"
        @rowClick="rowClick"
      ></ListForm>
    </v-dialog>

    <p v-if="header" v-bind="header">{{ header.label }}</p>

    <ReactiveDynamicForm
      v-if="form != null"
      :key="updates"
      :schema="form.schema"
      :entity-id="entityId"
      :value="selectedEntryValue"
      ref-mode
      @refShowList="showListFormDialog"
      @refClearSelection="clearSelection()"
    ></ReactiveDynamicForm>

    <v-alert
      v-if="showButtons"
      :value="!isValid()"
      border="left"
      elevation="2"
      colored-border
      type="error"
      >{{ requiredMessage }}</v-alert
    >

    <!-- <v-flex v-if="showButtons === true">
      <v-layout justify-end>
        <v-btn icon @click="showListFormDialog()">
          <v-icon>layers</v-icon>
        </v-btn>
        <v-btn icon @click="clearSelection()">
          <v-icon>layers_clear</v-icon>
        </v-btn>
      </v-layout>
    </v-flex> -->
  </component>
</template>
<script>
import ApiService from '../APIService'
export default {
  name: 'RefWidget',
  components: {
    ListForm: () => import('../forms/ListForm.vue'),
    ReactiveDynamicForm: () => import('../ReactiveDynamicForm')
  },
  props: {
    entityId: {
      type: String,
      default: null
    },
    header: {
      type: Object,
      default: null
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    requiredMessage: {
      type: String,
      default: 'Please select a row from above',
      required: false
    },
    validateRequestCounter: {
      type: Number,
      required: false,
      default: 0
    },
    dismissCardView: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: null
    },
    refreshTargets: {
      type: Array,
      default: null
    },
    hardFilters: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      selectedEntry: this.value || { entryId: null, entityId: null },
      selectedEntryValue: null,
      updates: 0,
      listUpdates: 0,
      form: null
    }
  },
  computed: {
    wrapper: function() {
      return this.dismissCardView == null || this.dismissCardView === false
        ? 'v-card'
        : 'div'
    }
  },
  watch: {
    selectedEntry: {
      handler: function(newValue) {
        if (this.selectedEntry == null) {
          this.$emit('input', null)
        } else {
          this.$emit('input', {
            entityId: this.selectedEntry.entityId,
            entryId: this.selectedEntry.entryId
          })
        }
        if (this.refreshTargets != null && this.refreshTargets.length > 0) {
          this.$emit('refreshRequested', {
            targets: this.refreshTargets,
            invokerSnapshot: newValue
          })
        }
      },
      deep: true
    }
  },
  created() {
    //console.log("SELECTED ENTRY: " + JSON.stringify(this.selectedEntry))
    if (this.form == null) {
      ApiService.getForm(this.entityId, 'ref')
        .then((res) => {
          if (res.status !== 200) {
            console.log('Could not fetch CRUD Form: ')
            console.log(res.statusText)
          } else {
            this.doubleRef(res.data.schema)
            this.makeSchemaReadOnly(res.data.schema)
            this.removeRequiredProp(res.data.schema)
            // --<
            // TODO Adaugam butoanele de ref pe ultimul widget din form
            if (this.showButtons) {
              this.addRefButtonsToSchema(res.data.schema)
            }
            this.form = res.data

            // console.log("%cFetched crud form data", "color: #0c0");
            this.getSelectedEntryValue()
          }
        })
        .catch((error) => {
          console.log(
            'Error fetching crud form for CrudForm.vue: ' +
              JSON.stringify(error)
          )
        })
    }
  },
  methods: {
    getSelectedEntryValue() {
      if (
        this.selectedEntry.entryId != null &&
        this.selectedEntry.entityId != null
      ) {
        ApiService.getEntry(
          this.selectedEntry.entityId,
          this.selectedEntry.entryId
        )
          .then((res) => {
            this.selectedEntryValue = res.data
            this.updates++
          })
          .catch((error) => {
            console.log(
              'Could not refresh selected entry value in ref form ' +
                JSON.stringify(error)
            )
            this.selectedEntryValue
          })
      }
    },
    rowClick(value) {
      this.selectedEntry.entityId = this.entityId
      this.selectedEntry.entryId = value._id
      this.dialog = false

      this.getSelectedEntryValue()
      this.$emit('validate', this.isValid())
      this.$emit('refChanged', this.selectedEntry)
      this.updates++
    },
    addRefButtonsToSchema(schema) {
      if (schema == null) {
        return
      }
      let lastWidget = Object.keys(schema)[Object.keys(schema).length - 1]
      schema[lastWidget].refSpecs = {}
    },
    makeSchemaReadOnly: function(schema) {
      Object.keys(schema).forEach((key) => {
        schema[key].readonly = true
      })
    },
    doubleRef: function(schema) {
      Object.keys(schema).forEach((key) => {
        if (schema[key].type === 'ref') {
          schema[key].showButtons = false
        }
      })
    },
    removeRequiredProp(schema) {
      Object.keys(schema).forEach((key) => {
        if (schema[key].required === true) {
          schema[key].required = false
        }
        if (schema[key].rules != null) {
          schema[key].rules = null
        }
      })
    },
    showListFormDialog() {
      this.dialog = true
      this.listUpdates++
    },
    clearSelection() {
      this.selectedEntry = { entityId: null, entryId: null }
      this.selectedEntryValue = null
      this.$emit('validate', this.isValid())
      this.$emit('refChanged', this.selectedEntry)
      this.updates++
    },
    isValid() {
      return (
        !this.required ||
        (this.selectedEntry != null &&
          this.selectedEntry.entityId != null &&
          this.selectedEntry.entryId != null)
      )
    }
  }
}
</script>
